import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ProductCard() {
  const revealRef = useScrollReveal();
  return <section id="producto" className="relative bg-brand-violetDark py-10 px-[5%] overflow-hidden" data-id="element-155">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_rgba(201,169,110,0.08)_0%,_transparent_60%)] pointer-events-none" data-id="element-156" />

      <div ref={revealRef} className="max-w-[900px] mx-auto relative z-10 reveal" data-id="element-157">
        <div className="text-center mb-[56px]" data-id="element-158">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-159">
            EL PROTOCOLO
          </div>
          <h2 className="font-display italic text-[48px] text-brand-cream leading-tight" data-id="element-160">
            Tu inversión en la transformación
          </h2>
        </div>

        <div className="bg-white/[0.03] border border-brand-gold/35 rounded-[24px] overflow-hidden relative" data-id="element-161">
          <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-brand-violet via-brand-gold to-brand-cream" data-id="element-162" />

          <div className="flex flex-col md:flex-row" data-id="element-163">
            {/* Left Column - Book Mockup */}
            <div className="md:w-[40%] bg-brand-gold/5 p-[48px_40px] flex items-center justify-center relative" data-id="element-164">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.25)_0%,_transparent_70%)] blur-[80px] -z-10" data-id="element-165" />

              <div className="relative" style={{
              transform: 'perspective(800px) rotateY(-8deg)'
            }} data-id="element-166">
                <img src="https://cdn.magicpatterns.com/uploads/okFEir8M4AQMPTjnkjVmQW/RENACER.png" alt="RENACER: El Protocolo Cuántico" className="w-[280px] rounded-[8px] shadow-[-8px_8px_32px_rgba(0,0,0,0.6)] object-cover" data-id="element-167" />
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="md:w-[60%] p-[48px_40px]" data-id="element-168">
              <h3 className="font-display text-[28px] font-medium text-brand-cream mb-1" data-id="element-169">
                RENACER: El Protocolo Cuántico
              </h3>
              <p className="font-body text-[13px] text-brand-muted mb-6" data-id="element-170">
                Edición Maestro: Transmutación del Inconsciente
              </p>

              <div className="inline-flex items-center bg-[#DC3232]/15 border border-[#DC3232]/30 text-[#FF6B6B] text-[12px] py-[5px] px-[14px] rounded-[40px] mb-5" data-id="element-171">
                ⚡ Precio de lanzamiento — tiempo limitado
              </div>

              <div className="flex items-baseline gap-3 mb-5" data-id="element-172">
                <span className="font-body text-[18px] text-brand-cream/30 line-through" data-id="element-173">
                  $47.00
                </span>
                <span className="font-display text-[52px] font-medium text-brand-gold leading-none" data-id="element-174">
                  $6.39
                </span>
              </div>

              <div className="w-full h-[1px] bg-white/[0.08] my-5" data-id="element-175" />

              <a href="https://learniacademy.com/cart/53230890647917:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full text-center bg-brand-gold text-brand-dark font-body text-[15px] font-medium tracking-[0.03em] py-[18px] rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_8px_28px_rgba(201,169,110,0.35)] mb-6" data-id="element-176">
                OBTENER EL PROTOCOLO — $6.39
              </a>

              <div className="flex flex-col gap-3" data-id="element-177">
                {['Descarga inmediata al correo tras el pago', '3 módulos + módulo especial activación pineal', 'Técnicas, meditaciones y checklists aplicables hoy', 'Acceso de por vida al archivo descargado'].map((item, i) => <div key={i} className="flex items-start gap-[10px] font-body text-[14px] text-brand-cream/80 py-[6px]" data-id="element-178">
                    <span className="text-brand-gold mt-[2px]" data-id="element-179">✦</span>
                    {item}
                  </div>)}
              </div>

              <div className="flex items-center justify-center gap-2 mt-[14px]" data-id="element-180">
                <span data-id="element-181">🛡️</span>
                <span className="font-body text-[13px] text-brand-cream/50" data-id="element-182">
                  Garantía 7 días — si no te transforma, te devolvemos el dinero
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}